import React, { useMemo, useContext } from "react";
import {
  CustomPropertyKeys,
  RouterPaths,
  TranslationKeys,
} from "../../../infrastructure/const";
import CheckUtils from "../../../utilities/check-utils";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import useVatExempt from "./useVatExempt";

interface VatExemptCheckboxProps {
  onUpdate: (isChecked: boolean) => void;
  properties: Record<string, any>;
}

const VatExemptCheckbox: React.FC<VatExemptCheckboxProps> = ({
  onUpdate,
  properties,
}) => {
  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  const { isApplied } = useVatExempt();

  return (
    <div className="vat-block">
      <form>
        <input
          checked={isApplied(properties)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onUpdate(e.target.checked)
          }
          type="checkbox"
          name="vatrelief"
          id="vatrelief"
          className="hidden-checkbox css-checkbox"
        />
        <label className="css-label" htmlFor="vatrelief">
          <strong>
            {translationManager.getTranslation(
              TranslationKeys.UK.CART_VAT_LABEL
            )}
          </strong>
          <span>
            {translationManager.getTranslation(
              TranslationKeys.UK.CART_VAT_DESCRIPTION
            )}
            &nbsp;
            <a
              href={RouterPaths.CustomerServiceVatExempt}
              onClick={(e) => {
                e.preventDefault();
                window.open(RouterPaths.CustomerServiceVatExempt);
              }}
            >
              {translationManager.getTranslation(TranslationKeys.READMORE)}
            </a>
          </span>
        </label>
      </form>
    </div>
  );
};

export default VatExemptCheckbox;
